import { Checkbox, FormControl } from "@mui/material";
import { default as React } from "react";
import { getCategoryById, getCategories } from "./categoryHelper";

export function SubCategories(props) {
  const categoryId = props.categoryId;
  const values = props.values;
  const onChange = props.onChange;
  if (!categoryId) {
    return null;
  }
  const categoryObject = getCategoryById(categoryId);
  if (!categoryObject) {
    return null;
  }

  if (categoryObject.subCategories.length === 0) {
    return null;
  }

  const asdf = function (name, status) {
    let newValues = values.map((v) => v);
    if (status === false) {
      newValues = values.filter((v) => v !== name);
    } else if (status === true) {
      newValues.push(name);
    }
    onChange(newValues);
  };
  return (
    <FormControl component="fieldset" variant="standard">
      <div>
        {categoryObject.subCategories.map(function (sub) {
          return (
            <label
              key={sub}
              style={{
                fontColor: "primary",
                display: "inline-block",
                marginRight: "10px",
                padding: "5px",
                whiteSpace: "nowrap",
              }}
            >
              <Checkbox
                key={sub}
                id={sub}
                checked={values.includes(sub)}
                onChange={(event) => asdf(sub, event.target.checked)}
              />
              {sub}
            </label>
          );
        })}
      </div>
    </FormControl>
  );
}
